class UgcFeed extends HTMLElement {
  connectedCallback() {
    this._carousel = this.querySelector('scroll-carousel');
    this._abortController = new AbortController();
    this._repositionHandler = () => UgcFeed._positionTooltip(UgcFeed._activeButton);
    this._initProductTags();
    this._initScrollTracking();
    this._initDocumentListeners();
  }

  disconnectedCallback() {
    this._abortController?.abort();
    window.removeEventListener('scroll', this._repositionHandler);
    this._carousel?.removeEventListener('scroll', this._repositionHandler);
    UgcFeed._closeTooltip();
  }

  static _getTooltip() {
    if (!UgcFeed._tooltip) {
      const tooltip = document.createElement('div');
      tooltip.className = 'ugc-feed-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      tooltip.hidden = true;
      tooltip.addEventListener('click', (e) => e.stopPropagation());
      document.body.appendChild(tooltip);
      UgcFeed._tooltip = tooltip;
    }
    return UgcFeed._tooltip;
  }

  static _positionTooltip(btn) {
    const tooltip = UgcFeed._getTooltip();
    if (tooltip.hidden || !btn) return;

    const btnRect = btn.getBoundingClientRect();
    const tRect = tooltip.getBoundingClientRect();

    let top = btnRect.top - tRect.height - 8;
    if (top < 8) top = btnRect.bottom + 8;

    let left = btnRect.left + btnRect.width / 2 - tRect.width / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - tRect.width - 8));

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
  }

  static _closeTooltip() {
    const tooltip = UgcFeed._getTooltip();
    tooltip.hidden = true;
    if (UgcFeed._activeButton) {
      UgcFeed._activeButton.setAttribute('aria-expanded', 'false');
      UgcFeed._activeButton = null;
    }
  }

  _initDocumentListeners() {
    if (UgcFeed._documentListenerAdded) return;
    UgcFeed._documentListenerAdded = true;
    document.addEventListener('click', () => UgcFeed._closeTooltip());
  }

  _initProductTags() {
    const { signal } = this._abortController;

    this.querySelectorAll('[data-product-tag]').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();

        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        UgcFeed._closeTooltip();
        if (isExpanded) return;

        const { productTitle: title = '', productPrice: price = '', productUrl: url = '#', productImage: image = '' } = button.dataset;

        const imgHtml = image
          ? `<img src="${image}" alt="${title.replace(/"/g, '&quot;')}" class="ugc-feed-tooltip__image" width="39" height="52">`
          : '';

        const tooltip = UgcFeed._getTooltip();
        tooltip.innerHTML = `
          <a href="${url}" class="ugc-feed-tooltip__link">
            ${imgHtml}
            <div class="ugc-feed-tooltip__info">
              <p class="ugc-feed-tooltip__name">${title}</p>
              <p class="ugc-feed-tooltip__price">${price}</p>
            </div>
          </a>
        `;

        tooltip.hidden = false;
        UgcFeed._activeButton = button;
        UgcFeed._positionTooltip(button);
        button.setAttribute('aria-expanded', 'true');

      }, { signal });
    });
  }

  _initScrollTracking() {
    window.addEventListener('scroll', this._repositionHandler, { passive: true });
    this._carousel?.addEventListener('scroll', this._repositionHandler, { passive: true });
  }
}

UgcFeed._tooltip = null;
UgcFeed._activeButton = null;
UgcFeed._documentListenerAdded = false;

if (!window.customElements.get('ugc-feed')) {
  window.customElements.define('ugc-feed', UgcFeed);
}
